import { render, staticRenderFns } from "./working-policy-form.vue?vue&type=template&id=4f0bc8f3&"
import script from "./working-policy-form.vue?vue&type=script&lang=js&"
export * from "./working-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports